export { EligibilityScope } from './generated/EligibilityScope.js';